import { render, staticRenderFns } from "./BaseProductSeriesConfigurationItem.vue?vue&type=template&id=19f406d4&scoped=true"
import script from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
export * from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./BaseProductSeriesConfigurationItem.vue?vue&type=style&index=0&id=19f406d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f406d4",
  null
  
)

export default component.exports